import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-our-team-details',
  templateUrl: './our-team-details.component.html',
  styleUrls: ['./our-team-details.component.css']
})
export class OurTeamDetailsComponent implements OnInit {

  constructor(private _Activatedroute: ActivatedRoute,private homeService_: HomeService) { }
  id:any
  TeamName:string = ''
  TeamDsc:string = ''
  TeamImage:string= ''
  TeamDetails:string = ''
  load:boolean=false
  getSectionOurTeamDetails:any
  googlescholer: any
  linkedin: any
  publons: any
  email:any
  email2:any;
  showEmail2:number=0;

  ngOnInit(): void {
this.load = false
this.showEmail2=0;
    this.id = this._Activatedroute.snapshot.paramMap.get("id")

    this.homeService_.getPost('getPostById',this.id, 'en', '', 'TeamMember', '', '', '1').subscribe((data:any) => {
      let arr = data as any[]
      this.TeamName = arr[0]['postTitle']
      this.TeamDsc = arr[0]['postSubTitle']
      this.TeamImage = arr[0]['postImage']
      this.TeamDetails = arr[0]['postDetails']
      this.googlescholer=arr[0]['team_GoogleSchoolar']
      this.linkedin=arr[0]['team_Linkedin']
      this.publons=arr[0]['team_Publons']
      this.email=arr[0]['team_Email'] 
      this.email2=arr[0]['team_Email2']
      // if(arr[0]['team_Email2'].length>0)
      // {
        
      //   this.showEmail2=1;
      //   this.email2=arr[0]['team_Email2']
      // }
     

      // this.TeamPhone = arr[0]['TeamPhone']
      // this.homeService_.getPost('getPostById',this.id, 'en', '', 'ResearchTopics', '', '', '1').subscribe(data => {
      //   this.getSectionOurTeamDetails = data
      //   this.load = true
      // })
      this.load = true
    });
  }

}
